import React from 'react';
import { openFranchiseFinmodelForm } from './franchiseConstants';

export function MarketingSection() {
  return (
    <section id="s-marketing" className="franchise-section">
      <div className="franchise-section__inner">
        <div className="franchise-marketing" data-reveal>
          <div className="franchise-marketing__background"> </div>
          <div className="franchise-marketing__banner">МАРКЕТИНГ, <br /> КОТОРЫЙ ПРИВОДИТ <br /> ГОСТЕЙ</div>
          <div className="franchise-marketing__images">
            <img src="/assets/media/franchise/marketing-section/image1.png" alt="Акции" />
            <img src="/assets/media/franchise/marketing-section/image2.png" alt="Акции" />
            <img src="/assets/media/franchise/marketing-section/image3.png" alt="Акции" />
          </div>
          <div className="franchise-marketing__body">
            <div className="franchise-marketing__body__container">
              <div className="franchise-marketing__body__container__text">Креативов <br /> ежемесячно</div>
              <div className="franchise-marketing__body__container__nums__first">100+</div>
            </div>
            <div className="franchise-marketing__body__container">
              <div className="franchise-marketing__body__container__text">Централизованный <br /> маркетинг</div>
              <div className="franchise-marketing__body__container__nums">
                <svg width="55" height="42" viewBox="0 0 55 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.82764 16.0829L21.8276 37.5115L52.3276 1.61865" stroke="#FF0000" strokeWidth="5" />
                </svg>
              </div>
            </div>
            <div className="franchise-marketing__body__container">
              <div className="franchise-marketing__body__container__text">Быстрый запуск <br /> акций</div>
              <div className="franchise-marketing__body__container__nums">
                <svg width="55" height="42" viewBox="0 0 55 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.82764 16.0829L21.8276 37.5115L52.3276 1.61865" stroke="#FF0000" strokeWidth="5" />
                </svg>
              </div>
            </div>
          </div>
          <button type="button" className="franchise-marketing__button" onClick={openFranchiseFinmodelForm()}>Получить <br /> финансовую модель</button>
          <img className="franchise-marketing__fish" src="/assets/media/franchise/marketing-section/fish.svg" alt="Рыбки" />
        </div>
      </div>
    </section>
  );
}
